import { useAuth } from "@/hooks/useAuth";
import { DashboardOperador } from "./dashboards/DashboardOperador";
import { DashboardAdmin } from "./dashboards/DashboardAdmin";

export function HomePage() {
  const { user } = useAuth();
  if (!user) return null;

  if (user.rol === "admin_central") return <DashboardAdmin user={user} />;
  return <DashboardOperador user={user} />;
}
